import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Nav } from 'react-bootstrap5';

export default function Pagination({ feedbacks, eventKey }) {
  const firstId = feedbacks[0].id;
  const lastId = feedbacks[feedbacks.length - 1].id;

  const [activeId, setActiveId] = useState(firstId);
  const activeIndex = feedbacks.findIndex((feedback) => feedback.id === activeId);

  const prevId = activeIndex > 0 ? feedbacks[activeIndex - 1].id : null;
  const nextId = activeIndex < (feedbacks.length - 1) ? feedbacks[activeIndex + 1].id : null;

  return (
    <footer className="d-flex justify-content-end align-items-center">
      <div className="me-3" style={{ marginTop: '2px' }}>
        {activeIndex + 1}
        {' of '}
        {feedbacks.length}
      </div>

      <Nav>
        <Nav.Item key="member-feedback-page-first">
          <Nav.Link
            eventKey={eventKey(firstId)}
            onClick={() => setActiveId(firstId)}
            disabled={activeId === firstId}
            className="icon-with-text"
          >
            <i className="first-page-icon small-icon" />
          </Nav.Link>
        </Nav.Item>

        <Nav.Item key="member-feedback-page-prev" className="ms-2">
          <Nav.Link
            eventKey={eventKey(prevId)}
            onClick={() => setActiveId(prevId)}
            disabled={!prevId}
            className="icon-with-text"
          >
            <i className="prev-page-icon small-icon" />
          </Nav.Link>
        </Nav.Item>

        <Nav.Item key="member-feedback-page-next" className="ms-2">
          <Nav.Link
            eventKey={eventKey(nextId)}
            onClick={() => setActiveId(nextId)}
            disabled={!nextId}
            className="icon-with-text"
          >
            <i className="next-page-icon small-icon" />
          </Nav.Link>
        </Nav.Item>

        <Nav.Item key="member-feedback-page-last" className="ms-2">
          <Nav.Link
            eventKey={eventKey(lastId)}
            onClick={() => setActiveId(lastId)}
            disabled={activeId === lastId}
            className="icon-with-text"
          >
            <i className="last-page-icon small-icon" />
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </footer>
  );
}

Pagination.propTypes = {
  feedbacks: PropTypes.arrayOf(PropTypes.object).isRequired,
  eventKey: PropTypes.func.isRequired,
};
